export enum ParameterConstants {
    USERNAME = 'username',
    PASSWORD = 'password'
}

export enum RoutePaths {
    HOME = '/',
    WISHES = '/wishes',
    WISH_DETAILS = '/wishes/:wishId',
    WISH_WINNER = '/wishes/:wishId/winner',
    ABOUT = '/about',
    BLOGS = '/blogs',
    BLOG_DETAILS = '/blogs/:blogId',
    TERMS = '/terms',
    PRIVACY = '/privacy',
    CONTACT = '/contact',
    GUIDE = '/guide',
    FAQ = '/faq',
    AUTH = '/auth',
    PROFILE = '/profile',
    HOW_IT_WORKS = '/how-it-works',
    FORGOT_PASSWORD = '/forgot-password',
    RESET_PASSWORD = '/reset-password/:confirmationId',
    EMAIL_CONFIRMATION = '/email-confirmation/:confirmationId',
    UNSUBSCRIBE_NEWSLETTER = '/unsubscribe-newsletter/:userEmailHex',
    ADMIN_PANEL_LOGIN = '/admin-panel/login',
    ADMIN_PANEL_DASHBOARD = '/admin-panel/dashboard',
    ADMIN_PANEL_WISHES = '/admin-panel/wishes',
    ADMIN_PANEL_CATEGORIES = '/admin-panel/categories',
    ADMIN_PANEL_QUESTIONS = '/admin-panel/questions',
    ADMIN_PANEL_CLIENTS = '/admin-panel/clients',
    ADMIN_PANEL_MESSAGES = '/admin-panel/messages',
    ADMIN_PANEL_EXPENSES = '/admin-panel/expenses',
    ADMIN_PANEL_BLOGS = '/admin-panel/blogs',
    ADMIN_PANEL_NOTIFICATIONS = '/admin-panel/notifications',
    ADMIN_PANEL_DOCUMENTS = '/admin-panel/documents',
    ADMIN_PANEL_IMAGES = '/admin-panel/images',
    ADMIN_PANEL_CONFIG = '/admin-panel/config',
    ADMIN_PANEL_EMAILS = '/admin-panel/emails',
    CLIENT_PANEL_DASHBOARD = '/client-panel/dashboard',
    CLIENT_PANEL_VOUCHERS = '/client-panel/vouchers',
    CLIENT_PANEL_DRAWS = '/client-panel/draws',
}

export enum StorageConstants {
    USER_INFO = 'user_info',
    LANGUAGE = 'language',
    SELECTED_CATEGORY_ID = 'selected_category_id',
    COOKIES_ALLOWED = 'cookies_allowed',
    PWA_PROMPT_RESPONSE = 'pwa_prompt_response',
    NOTIFICATIONS_UNREAD = 'notifications_unread',
    HOME_PROMO_DISMISSED = 'home_promo_dismissed',
}

export enum CfgAttributesNames {
    HOME = "home",
    HOW_IT_WORKS = "how-it-works",
    PARTNERS = "partners",
    CONTACT_US = "contact-us",
    FAQ = 'faq',
    FEATURE_TOGGLES = 'feature-toggles',
}

export enum SocialLoginType {
    FACEBOOK = 'facebook',
    GOOGLE = 'google'
}

export enum DocumentType {
    PRIVACY = 'privacy',
    TERMS = 'terms',
    ABOUT = 'about',
    GUIDE = 'guide',
}
